/**
 * @prettier
 */

import {
    POA_DOCUMENTS_LOADING,
    POA_DOCUMENTS_LOADED,
    POA_DOCUMENTS_ERROR,
    POA_DOCUMENT_UPLOADED,
    POA_SET_COMPLETED,
    POA_RESET_STATE,
    POA_SET_LOADING,
} from "../actions/poaDocumentsActions";

const initialState = {
    loading: false,
    error: null,
    documents: [],
    additionalDocuments: [],
    poaStatusMap: {},
    additionalStatusMap: {},
    allRequiredUploaded: false,
    poaRequiredUploaded: false,
    additionalRequiredUploaded: false,
    isCompleted: false,
};

export function poaDocumentsReducer(state = initialState, { type, payload }) {
    switch (type) {
        case POA_SET_LOADING:
            return {
                ...state,
                loading: !!payload?.isLoading,
            };

        case POA_DOCUMENTS_LOADING:
            return {
                ...state,
                loading: true,
                error: null,
            };

        case POA_DOCUMENTS_LOADED:
            return {
                ...state,
                loading: false,
                error: null,
                documents: payload?.documents ?? [],
                additionalDocuments: payload?.additionalDocuments ?? [],
                poaStatusMap: payload?.poaStatusMap ?? {},
                additionalStatusMap: payload?.additionalStatusMap ?? {},
                // If payload doesn't have allRequired, keep the current state as a boolean value
                allRequiredUploaded: !!payload?.allRequiredUploaded,
                poaRequiredUploaded: !!payload?.poaRequiredUploaded,
                additionalRequiredUploaded:
                    !!payload?.additionalRequiredUploaded,
                // If payload doesn't have isCompleted, we keep the current state value
                isCompleted: payload?.isCompleted ?? state.isCompleted,
            };

        case POA_DOCUMENTS_ERROR:
            return {
                ...state,
                loading: false,
                error: payload,
            };

        case POA_DOCUMENT_UPLOADED: {
            const { isPoaDocument, documentId } = payload ?? {};
            if (!documentId) return state;

            return {
                ...state,
                poaStatusMap: isPoaDocument
                    ? { ...state.poaStatusMap, [documentId]: true }
                    : state.poaStatusMap,
                additionalStatusMap: !isPoaDocument
                    ? { ...state.additionalStatusMap, [documentId]: true }
                    : state.additionalStatusMap,
            };
        }

        case POA_SET_COMPLETED: {
            return {
                ...state,
                isCompleted: payload.isCompleted,
            };
        }

        case POA_RESET_STATE:
            return initialState;

        default:
            return state;
    }
}
